export const Types = {
    START_EDIT_BREAK_TAG: "START_EDIT_BREAK_TAG",
    END_EDIT_BREAK_TAG: "END_EDIT_BREAK_TAG",
    SUBMIT_BREAK_TAG_EDIT: "SUBMIT_BREAK_TAG_EDIT",
    SUBMITTED_BREAK_TAG_EDIT: "SUBMITTED_BREAK_TAG_EDIT",
    UPDATE_BREAK_TAG_FIELD_ERROR: "UPDATE_BREAK_TAG_FIELD_ERROR",

    START_EDIT_BREAK_SITE_TAG: "START_EDIT_BREAK_SITE_TAG",

};

export const startEditBreakTagAction = (tag, {postCreateAction, postEditAction}) => ({
    type: Types.START_EDIT_BREAK_TAG,
    tag,
    postCreateAction,
    postEditAction
});

export const endEditBreakTagAction = () => ({
    type: Types.END_EDIT_BREAK_TAG
});

export const submitBreakTagEditAction = () => ({
    type: Types.SUBMIT_BREAK_TAG_EDIT
});

export const submittedBreakTagEditAction = () => ({
    type: Types.SUBMITTED_BREAK_TAG_EDIT
});

export const updateBreakTagFieldError = (field, error, value) => ({
    type: Types.UPDATE_BREAK_TAG_FIELD_ERROR,
    field,
    error,
    value
});

export const startEditBreakSiteTagAction = (tag, {postCreateAction, postEditAction}) => ({
    type: Types.START_EDIT_BREAK_SITE_TAG,
    tag,
    postCreateAction,
    postEditAction
});



// WEBPACK FOOTER //
// ./public/pages/EditBreak/BreakTagModal/actions.js